// extracted by mini-css-extract-plugin
export default {"wrapper":"keyboard_wrapper__sUsQu","keypad":"keyboard_keypad__g+lVt","key":"keyboard_key__eE0mY","keyOk":"keyboard_keyOk__0cCOf"};